<div class="clinic-layout">
  <header class="clinic-header" role="banner">
    <div class="clinic-header-inner">
      <div class="clinic-header-top" id="clinic-header-top">
        <h1 class="clinic-title">{{ appTitle }}</h1>

        <div class="clinic-header-actions">
          <!-- Notifications -->
          <lib-notifications iconColor="light" appType="clinic"></lib-notifications>

          <!-- Profile -->
          <div class="clinic-profile-menu" role="presentation">
            <button
              type="button"
              class="clinic-profile-trigger"
              [class.clinic-profile-trigger--active]="isProfileOpen"
              (click)="toggleProfile()"
              [attr.aria-expanded]="isProfileOpen"
              aria-haspopup="true"
            >
              <div class="clinic-profile-info">
                <span class="clinic-profile-name">{{ userFullName }}</span>
              </div>
              <div class="clinic-profile-avatar" aria-hidden="true">
                @if (userAvatarUrl()) {
                <img
                  [src]="userAvatarUrl()"
                  alt="User Avatar"
                  class="clinic-avatar-img"
                />
                } @else if (userInitials) {
                <span class="clinic-avatar-initials">{{ userInitials }}</span>
                } @else {
                <span class="material-icons clinic-profile-icon">person</span>
                }
              </div>
            </button>

            @if (isProfileOpen) {
            <div class="clinic-profile-dropdown" role="menu">
              <div class="clinic-profile-dropdown-header">
                <span class="clinic-profile-dropdown-name">{{
                  userFullName
                }}</span>
                <span class="clinic-profile-dropdown-email">{{
                  userEmail
                }}</span>
              </div>

              <div class="clinic-profile-dropdown-sep"></div>

              <div class="clinic-profile-dropdown-items">
                <button
                  type="button"
                  class="clinic-profile-dropdown-item"
                  role="menuitem"
                  (click)="openSettings()"
                >
                  <span class="material-icons">settings</span>
                  <span>{{ 'COMMON.SETTINGS' | translate }}</span>
                </button>

                @if (isAuthorizedForAccount()) {
                <button
                  type="button"
                  class="clinic-profile-dropdown-item"
                  role="menuitem"
                  (click)="navigateToProfile()"
                >
                  <span class="material-icons">account_balance</span>
                  <span>{{ 'COMMON.ACCOUNT' | translate }}</span>
                </button>
                }
              </div>

              <div class="clinic-profile-dropdown-sep"></div>

              <button
                type="button"
                class="clinic-profile-dropdown-item clinic-profile-logout"
                role="menuitem"
                (click)="logout()"
              >
                <span class="material-icons">logout</span>
                <span>{{ 'COMMON.LOGOUT' | translate }}</span>
              </button>
            </div>
            }
          </div>
        </div>
      </div>
      <nav class="clinic-tabs" role="navigation" aria-label="Ana menü">
        @for (item of menuItems; track item.route) {
        <a
          [routerLink]="item.route"
          routerLinkActive="clinic-tab-active"
          [routerLinkActiveOptions]="{ exact: item.route === '/main' }"
          class="clinic-tab"
          role="tab"
          (click)="onTabClick($event)"
        >
          <span class="material-icons clinic-tab-icon">{{ item.icon }}</span>
          <span class="clinic-tab-label">{{ item.label | translate }}</span>
        </a>
        }
      </nav>
    </div>
  </header>
  <main class="clinic-main" role="main">
    <ng-content></ng-content>
  </main>

  <!-- Ayarlar Modalı -->
  @if (showSettings()) {
  <div
    class="clinic-modal-overlay"
    (click)="closeSettings()"
    (keydown.escape)="closeSettings()"
    role="button"
    tabindex="0"
    aria-label="Kapat"
  >
    <div
      class="clinic-modal-content"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      role="document"
      tabindex="-1"
    >
      <div class="clinic-modal-header">
        <h2>{{ 'COMMON.SETTINGS' | translate }}</h2>
        <button
          type="button"
          class="clinic-modal-close"
          (click)="closeSettings()"
          aria-label="Kapat"
        >
          <span class="material-icons">close</span>
        </button>
      </div>
      <div class="clinic-modal-body">
        <lib-settings [hideLayout]="true"></lib-settings>
      </div>
    </div>
  </div>
  }

  <!-- Tema seçimi - sadece localhostta gözükür -->
  @if (isLocalhost) {
  <div class="clinic-theme-palette">
    <button
      type="button"
      class="clinic-theme-trigger"
      (click)="togglePalette()"
      [attr.aria-expanded]="isPaletteOpen"
      aria-label="Tema seç"
      title="Tema seçimi"
    >
      <span class="material-icons">color_lens</span>
    </button>
    @if (isPaletteOpen) {
    <div class="clinic-theme-panel" role="dialog" aria-label="Tema seçimi">
      <p class="clinic-theme-panel-title">Tema seçimi</p>
      <div class="clinic-theme-list">
        @for (opt of themeOptions; track opt.id) {
        <button
          type="button"
          class="clinic-theme-item"
          [class.clinic-theme-item-active]="
            themeService.currentPaletteId() === opt.id
          "
          (click)="selectTheme(opt.id)"
          [attr.aria-pressed]="themeService.currentPaletteId() === opt.id"
        >
          <span
            class="clinic-theme-item-color"
            [style.background-color]="opt.primaryColor"
            [style.border-color]="opt.headerColor"
          ></span>
          <span class="clinic-theme-item-label">{{ opt.label }}</span>
          @if (themeService.currentPaletteId() === opt.id) {
          <span class="material-icons clinic-theme-item-check">check</span>
          }
        </button>
        }
      </div>
    </div>
    }
  </div>
  }

  <lib-toast-container />
  <lib-confirm-dialog-container />
</div>
